// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__R8U6I","sizeSm":"Avatar_sizeSm__P1Cn3","sizeMd":"Avatar_sizeMd__7GIMp","sizeLg":"Avatar_sizeLg__fmM9Q","contractor":"Avatar_contractor__806YA"};